module.exports = __webpack_public_path__ + "img/stratigraphy.1d1d62c4.png";